var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.503 19.498c-2.257 0-4.098-1.813-4.247-4.158l-3.118-2.533c-.416.563-.802 1.126-1.099 1.751-.059.125-.089.282-.089.438 0 .188.03.344.09.47 1.603 3.313 4.81 5.533 8.463 5.533.772 0 1.544-.125 2.287-.313l-1.515-1.25c-.267.062-.534.062-.772.062zm9.295 1.845-3.266-2.689c.98-.875 1.811-1.97 2.405-3.189.06-.125.09-.281.09-.438 0-.187-.03-.344-.09-.469-1.604-3.314-4.81-5.565-8.434-5.565-1.604.031-3.088.438-4.395 1.188L6.336 7.117a.484.484 0 0 0-.297-.094c-.148 0-.297.063-.356.188l-.594.782A.548.548 0 0 0 5 8.305c0 .157.06.282.178.376L22.64 22.905c.09.063.178.094.297.094a.47.47 0 0 0 .386-.188l.564-.781a.548.548 0 0 0 .09-.313.454.454 0 0 0-.179-.375zm-5.434-4.44-1.188-.969c.119-.281.148-.594.178-.938v-.031c0-1.626-1.277-2.97-2.821-2.97-.267 0-.535.062-.802.125.178.25.267.563.297.875-.03.125-.03.219-.06.313l-2.197-1.751a4.278 4.278 0 0 1 2.732-1.063c2.346 0 4.276 2.032 4.276 4.502 0 .688-.178 1.313-.415 1.907z",
    fill: "#1E2B3B",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.e4474dd2d002f4adeb12a4d2a1c9aa53.svg";
export { ForwardRef as ReactComponent };